module.exports = __webpack_public_path__ + "img/map.a4289d2b.svg";